import { useCallback } from 'react';
import { Currency, FreightForwarder, Quote, QuoteCharge } from '../../types';

export function useQuoteCurrencyConversion(quote: Quote, freightForwarder: FreightForwarder) {
  const displayCurrencyCode = quote.displayCurrencyCode || freightForwarder?.baseCurrencyCode;
  const displayCurrency = quote.conversion_factors.find((c) => c.code === displayCurrencyCode) || {
    code: displayCurrencyCode,
    to_NZD: 1,
  };
  const conversionFactorsUsed: (Currency & { toDisplayCurrency: number })[] = quote.conversion_factors
    .filter((cf) => cf.code === displayCurrencyCode)
    .map((c) => ({ ...c, toDisplayCurrency: 1 }));
  const currencyIdsUsed = conversionFactorsUsed.map((c) => c._id);
  quote.charges.forEach((charge) => {
    if (!currencyIdsUsed.includes(charge.currency_id)) {
      currencyIdsUsed.push(charge.currency_id);
      // use quote conversion factr if is exists, otherwise freightForwarder conversion factor
      let currency =
        quote.conversion_factors.find((c) => c._id === charge.currency_id) ||
        freightForwarder?.currencies.find((c) => c._id === charge.currency_id);
      if (currency) {
        // conversionFactorsUsed.push({ ...currency, toDisplayCurrency: displayCurrency.to_NZD / currency.to_NZD });
        conversionFactorsUsed.push({ ...currency, toDisplayCurrency: currency.to_NZD / displayCurrency.to_NZD });
      }
    }
  });

  const getConversionToDisplayCurrency = useCallback(
    (code?: string) => {
      const conversionFactor = conversionFactorsUsed.find((c) => c.code === code);
      return conversionFactor ? conversionFactor.toDisplayCurrency : 1;
    },
    [conversionFactorsUsed]
  );

  const calcSellTotal = useCallback(
    (charges: QuoteCharge[]) => {
      let to_return = charges.reduce((accumulator, charge) => {
        const toDisplayCurrency = getConversionToDisplayCurrency(charge.currency?.code);
        return accumulator + (charge.calculatedSell || 0) * toDisplayCurrency;
      }, 0);
      return to_return;
    },
    [getConversionToDisplayCurrency]
  );

  return { conversionFactorsUsed, displayCurrency, calcSellTotal, getConversionToDisplayCurrency };
}
